export const AppConstants = {
  localStorage: {
    token: 'access_token',
    idToken: 'id_token',
    expireTime: 'expires_in',
    expireDate: 'expires_date',
    userType: 'user_type',
    tokenType: 'token_type',
    centreId: 'centre_id',
    centreName: 'centre_name',
    scope: 'scope',
    state: 'state',
    sessionState: 'session_state',
    userName: 'user-name',
    firstName: 'given_name',
    lastName: 'family_name',
    countryId: 'countryId',
    isBaseClinic: 'isBaseClinic',
    permissionOnPage: 'permissionOnPage',
    isActiveNewsFeed: 'isActiveNewsFeed',
    userAccount: 'preferred_username',
    userId: 'userId'
  },
  messageType: {
    invalidToken: 'InvalidToken',
    alreadyActived: 'AlreadyActived',
    activeSuccess: 'ActiveSuccess',
    accountIsDisabled: 'AccountIsDisabled'
  },
  activeLink: {
    userId: 'userId',
    token: 'token'
  },
  formConfig: {
    textBox: {
      maxLength: 200,
      minLength: 3,
      maxLengthNumberPhone: 24,
      filter: 'Search for {0}', // Search for <field name>”,
      datePlaceholder: "e.g. 01 Jan 2017"
    },
    textArea: {
      maxLength: 1000
    },
    selectBox: {
      default: 'Select {0}', // Select <field name>”
      filter: 'Show All {0}'// Show All <field name>”
    }
  },
  dateConfig: {
    date: 'DD MMM YYYY',
    hour: 'h:mm A',
    dateTime: 'DD MMM YYYY h:mm A', //
    dateFormat: '{0} {1} {2}', //DD MMM YYYY
    dateStringFormat: '{0}-{1}-{2}T00:00:00' // yyyy/mm/dd
  },
  pagingConfig: {
    pageSize: 15
  },
  uploadFileConfig: {
    image: ['svg', 'png', 'jpg', 'gif'],
    doc: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'],
    exel: ['xls', 'xlsx'],
    imageSize: 2 // 2MB
  },
  table: {
    footerClasses: {
      sortAscending: 'tmb-icon-arrow-up',
      sortDescending: 'tmb-icon-arrow-down',
      pagerLeftArrow: 'tmb-icon-arrow-left',
      pagerRightArrow: 'tmb-icon-arrow-right',
      pagerPrevious: 'tmb-icon-skip-prev',
      pagerNext: 'tmb-icon-skip-next'
    }
  },
  calendar: {
    timeslot: 10
  },
  reportParameter:{
    InvoiceNo: 'invoiceNo',
    currency: 'currencyCode',
    reportName: 'reportName',
    reportTokenId: 'reportTokenId',
    clinicId: 'clinicId',
    timezoneOffset: 'timezoneOffsetUtcLocal',
    printedBy: 'printedBy',
    vaccineId : 'vaccineId',
    consultationId : 'consultationId',
    patientId : 'patientId'
  },
  reportType: {
    AssociateClinic: {
      id: 'stolenvaccinationcertificate',
      name: 'Stolen Vaccination Certificate'
    },
  }
};



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/constants/constants.ts